import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Martín G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía L.',
  city: 'Córdoba'
}, {
  name: 'Lucas M.',
  city: 'Rosario'
}, {
  name: 'Valentina R.',
  city: 'Mendoza'
}, {
  name: 'Juan P.',
  city: 'La Plata'
}, {
  name: 'Camila S.',
  city: 'Mar del Plata'
}, {
  name: 'Nicolás F.',
  city: 'Tucumán'
}, {
  name: 'Agustina B.',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through purchases
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIdx = Math.floor(Math.random() * RECENT_PURCHASES.length);
        setCurrentPurchase(RECENT_PURCHASES[randomIdx]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500 max-w-xs w-full" data-id="element-7">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-[#D6B1BD] p-4 flex items-start gap-3 relative" data-id="element-8">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-9">
          <X size={14} data-id="element-10" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-11">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-12" />
        </div>

        <div data-id="element-13">
          <p className="text-sm font-bold text-gray-900" data-id="element-14">
            ¡Nueva compra verificada!
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-15">
            <span className="font-semibold" data-id="element-16">{currentPurchase.name}</span> de{' '}
            {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-17">
            Compró{' '}
            <span className="font-medium text-[#8B4A5C]" data-id="element-18">
              Sistema SALÍ DEL 99%
            </span>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-19">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}